import { FC, ReactNode } from "react";
import BookitupDocument from "../../types/BookitupDocument";
import { QRCodeSVG } from "qrcode.react";
import { Group, Space, Stack, Text } from "@mantine/core";

interface Props {
  invoice: BookitupDocument;
}

const InvoiceQrCodes: FC<Props> = ({ invoice }) => {
  const { epcQrPayment, paypalPaymentUrl } = invoice;
  const atLeastOneQrCodePresent = epcQrPayment || paypalPaymentUrl;

  if (!atLeastOneQrCodePresent) return null;

  return (
    <>
      <Space h="xl" />
      <Group position="center">
        {epcQrPayment && (
          <QrCodeWithDescription
            title="Überweisen per Code"
            description="Ganz bequem Code mit der Banking-App scannen."
            qrCode={epcQrPayment}
          />
        )}
        {paypalPaymentUrl && (
          <QrCodeWithDescription
            title="Bezahlen per PayPal"
            description={
              <Text>
                Ganz bequem Code scannen oder{" "}
                <a href={paypalPaymentUrl}>Link</a> verwenden.
              </Text>
            }
            qrCode={paypalPaymentUrl}
          />
        )}
      </Group>
    </>
  );
};

const QrCodeWithDescription: FC<{
  title: string;
  description: ReactNode;
  qrCode: string;
}> = ({ title, description, qrCode }) => {
  return (
    <Group
      p="xs"
      position="apart"
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: 4,
        width: 330,
      }}
    >
      <Stack spacing={0} sx={{ width: 200 }}>
        <Text mb="xs" size="xs" weight="bolder">
          {" "}
          {title}
        </Text>
        <Text size="xs">{description}</Text>
      </Stack>
      <div>
        <QRCodeSVG size={64} value={qrCode} />
      </div>
    </Group>
  );
};

export default InvoiceQrCodes;
